<action class="button-inline inline-block va-m"
        sizeClass="SM: c1, XL: p2"
        [status]="status"
        (click)="submit()"
        cy-basketAddButton>
    {{ buttonCopy }}
</action>
<result class="block"
        [status]="status"></result>
